'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isNode = exports.isNode = function isNode() {
  return typeof XMLHttpRequest === 'undefined';
};